import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import defaultMsg from '../../../translations/lang/en-US.json';

class DiningChangedPopup extends React.Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.state = {
      showModal: false,
    };
  }

  componentWillMount() {
    if (this.props.show) {
      this.setState({
        showModal: this.props.show,
      });
    }
  }

  close() {
    this.setState({ showModal: false }, function() {
      this.props.onDiningchangedCancel();
    });
  }

  render() {
    return (
      <Modal show={this.state.showModal} onHide={this.close} animation={true}>
        <Modal.Header>
          <h4 className="modal-title">
          <FormattedMessage id="itemsNotAvailableFor" defaultMessage={defaultMsg.itemsNotAvailableFor} /> {this.props.orderType()}
          </h4>
          <small>
            <FormattedMessage id="pleaseContinueToRemoveItem" defaultMessage={defaultMsg.pleaseContinueToRemoveItem} />
          </small>
        </Modal.Header>
        <Modal.Body>
          <ul className="list-group no-margin">
            {this.props.items.length > 0
              ? this.props.items.map(item => (
                  <li
                    className="list-group-item "
                    key={_.uniqueId('not-available-')}
                  >
                    {item.name}
                  </li>
                ))
              : null}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn diningButton"
            onClick={() => this.props.changeDiningOptionContinue()}
          >
            <FormattedMessage id='continue' defaultMessage={defaultMsg.continue} />
          </button>
          <button
            type="button"
            className="btn btn-primary diningButton"
            onClick={() => this.close()}
          >
            <FormattedMessage id='cancel' defaultMessage={defaultMsg.cancel} />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DiningChangedPopup;



// WEBPACK FOOTER //
// ./src/views/checkout/components/DiningChangedPopup.jsx